// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3ttTC","overflowing":"ReadFullNote_overflowing__33YEV"};